// angular
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// addons
import { map, take } from 'rxjs/operators';

// store
import { Store, select } from '@ngrx/store';
import * as fromStore from '@store/index';

// models
import { IUser } from '@shared/models';

@Injectable()
export class RoleRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store<fromStore.State>
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.store.pipe(
      select(fromStore.UserSelectors.getInfo),
      take(1),
      map((user: IUser) => {
        const roleFormUrl = state.url.split('/').join(' ').trim();
        const hasRoleInUrl = roleFormUrl.length > 0;

        if (hasRoleInUrl && roleFormUrl === user.role) { return true; }

        this.router.navigate([user.role]);

        return false;
      })
    );
  }
}
